import { DASH, formatDayBR, formatInstantDayBR, formatInt } from './format';

const ISO_INSTANT = /^\d{4}-\d{2}-\d{2}T/;
const ISO_DAY = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Valor cru do back-end para texto de tabela: instante vira dia local, dia vira dd/mm/aaaa,
 * booleano vira Sim/Não e vazio vira traço.
 */
export function formatCell(value: unknown, timeZone: string): string {
    if (value === null || value === undefined || value === '') return DASH;
    if (typeof value === 'boolean') return value ? 'Sim' : 'Não';
    if (typeof value === 'number') return formatInt(value);
    if (typeof value === 'string') {
        if (ISO_INSTANT.test(value)) return formatInstantDayBR(value, timeZone);
        if (ISO_DAY.test(value)) return formatDayBR(value);
        return value;
    }
    return String(value);
}
